import { render, staticRenderFns } from "./cardHead.vue?vue&type=template&id=0b9d458d&scoped=true&"
import script from "./cardHead.vue?vue&type=script&lang=js&"
export * from "./cardHead.vue?vue&type=script&lang=js&"
import style0 from "./cardHead.vue?vue&type=style&index=0&id=0b9d458d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9d458d",
  null
  
)

export default component.exports